import dayjs from 'dayjs';
import { create, StateCreator } from 'zustand';

import {
  PRINT_DATE_BIG1_FORMAT,
  PRINT_DATE_BIG1_FORMAT_PERIOD,
  PRINT_DATE_FORMAT_DAY,
  PRINT_DATE_FORMAT_MONTH,
} from '@/constants/datetime.constants';
import { PRINTING_TIME_TYPE } from '@/constants/tagfont.constants';
import { LabelStore } from '@/types/label.types';

const labelStore: StateCreator<LabelStore> = (set, get) => ({
  labelData: {},
  labelInputFocused: {},
  setLabelData: (labelData: LabelStore['labelData']) => {
    const previousLabelData = get().labelData;
    const printDate = labelData?.print_date ?? previousLabelData?.print_date;
    const printDateDisplay =
      labelData?.printing_time_type ?? previousLabelData?.printing_time_type;
    const isNotSpecifyPrintDateDisplay =
      printDateDisplay === PRINTING_TIME_TYPE['not-specify'];
    const isSpecifyPrintDateDisplay =
      printDateDisplay === PRINTING_TIME_TYPE.specify;
    const isPeriodPrintDateDisplay =
      printDateDisplay === PRINTING_TIME_TYPE.period;

    set({
      labelData: {
        ...previousLabelData,
        ...labelData,
        ...(isNotSpecifyPrintDateDisplay ||
        !printDate ||
        !printDateDisplay ||
        (printDate?.length && isSpecifyPrintDateDisplay) ||
        (!printDate?.length && isPeriodPrintDateDisplay)
          ? {
              print_date_month: '',
              print_date_day: '',
              print_date_start: '',
              print_date_end: '',
            }
          : {
              print_date_month: dayjs(
                isSpecifyPrintDateDisplay ? printDate : printDate?.[0],
              )
                .locale('en')
                .format(PRINT_DATE_FORMAT_MONTH)
                .toUpperCase(),
              print_date_day: dayjs(
                isSpecifyPrintDateDisplay ? printDate : printDate?.[0],
              )
                .locale('en')
                .format(PRINT_DATE_FORMAT_DAY),
              print_date_start: dayjs(
                isSpecifyPrintDateDisplay ? printDate : printDate?.[0],
              )
                .format(
                  isSpecifyPrintDateDisplay
                    ? PRINT_DATE_BIG1_FORMAT
                    : PRINT_DATE_BIG1_FORMAT_PERIOD,
                )
                .toUpperCase(),
              print_date_end: printDate?.[1]
                ? dayjs(printDate?.[1])
                    .format(PRINT_DATE_BIG1_FORMAT)
                    .toUpperCase()
                : '',
            }),
      },
    });
  },
  clearLabelData() {
    set({ labelData: {} });
  },
  setLabelFocus(labelInputFocused: LabelStore['labelInputFocused']) {
    const previousLabelInputFocused = get().labelInputFocused;
    set({
      labelInputFocused: { ...previousLabelInputFocused, ...labelInputFocused },
    });
  },
});

export const useLabelStore = create(labelStore);
